import React from 'react'
const estiloInputs = require('../../../../estilos/inputs.module.scss').default
const estiloOrcamentoEmAberto =
    require("../pendencia-cliente.module.scss").default;

export type VendedorRelacionadoProps = {
    onChangeSenha: (senha: string) => void
}

export const VendedorRelacionado = (props: VendedorRelacionadoProps) => {
    return <>
        <h4>O vendedor associado ao cliente é diferente do vendedor do orçamento, por favor, informe a senha de liberação.</h4>
        <div className={estiloOrcamentoEmAberto.form}>
            <label className={estiloInputs.labelObrigatorio}>Senha</label>
            <div>
                <input
                    type="password"
                    name="data-password" 
                    id="VendedorRelacionado_CampoSenha"
                    autoFocus
                    autoComplete="off"
                    aria-autocomplete="none"
                    onChange={(e) => props.onChangeSenha(e.target.value)}
                />
            </div>
        </div>
    </>
}
